import React from 'react';
import { Redirect } from 'react-router-dom';
import SessionStorageService from '../services/utilities/SessionStorageService';

export class LoginDispatcher extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: undefined,
    };

    this.authProvider = this.props.authProvider;
  }

  async componentDidMount() {
    // ログイン時にSessionStorageにFieldIdとそれに関連する情報を持っている場合は消す(自分の所属していない現場の可能性がある)。
    SessionStorageService.removeInformationRelatedToField();
    SessionStorageService.setAfterLoginEventsFlag(true);
    const loggedInUser = await this.authProvider.getLoggedInUser();
    this.setState({ user: loggedInUser });
  }

  render() {
    if (this.state.user === undefined) {
      return <div>ログイン情報の確認中です...</div>;
    }

    if (this.state.user === null) {
      this.authProvider.redirectLoginPage();
      return <div>ログイン情報の確認中です...</div>;
    }

    return <Redirect to='/callback' />;
  }
}



// WEBPACK FOOTER //
// ./src/components/LoginDispatcher.js